import {
  AddExceptionList,
  UpdateTrays,
  AddActiveTrays,
  AddCheckpointsSettings,
  DeleteTrays,
} from './../actions/checkpoint.action';
// NGXS
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { IActiveTray } from '../../models/service/active-trays.model';
import { Injectable } from '@angular/core';
import {
  ITrayline,
  IDeliveryException,
} from '../../models/service/checkpoints-settings.model';

// Models and interfaces

export interface CheckpointStateI {
  activeTrays: IActiveTray[];
  checkpoints: ITrayline[];
  exceptionList: IDeliveryException[];
}

@State<CheckpointStateI>({
  name: 'CheckpointState',
  defaults: {
    activeTrays: [],
    checkpoints: [],
    exceptionList: [],
  },
})
@Injectable({
  providedIn: 'root',
})
export class CheckpointState {
  @Selector()
  static getCheckpointState(state: CheckpointStateI): CheckpointStateI {
    return state;
  }
  @Selector()
  static getExceptionListState(state: CheckpointStateI): IDeliveryException[] {
    return state.exceptionList;
  }

  @Action(AddCheckpointsSettings)
  addCheckpointsSettings(
    { patchState }: StateContext<CheckpointStateI>,
    { payload }: AddCheckpointsSettings,
  ): void {
    patchState({
      checkpoints: [...payload],
    });
  }

  @Action(AddActiveTrays)
  addActiveTrays(
    { patchState }: StateContext<CheckpointStateI>,
    { payload }: AddActiveTrays,
  ): void {
    patchState({
      activeTrays: [...payload],
    });
  }
  @Action(AddExceptionList)
  AddExceptionList(
    { patchState }: StateContext<CheckpointStateI>,
    { payload }: AddExceptionList,
  ): void {
    patchState({
      exceptionList: [...payload],
    });
  }

  // For promote and demote
  @Action(UpdateTrays)
  UpdateTrays(
    { patchState, getState }: StateContext<CheckpointStateI>,
    { payload }: UpdateTrays,
  ): void {
    const currentActiveTraysState = [...getState().activeTrays];
    const traylineIndex = currentActiveTraysState.findIndex(
      tLine => tLine.trayLineOid === payload.trayLineOid,
    );
    let trayline = currentActiveTraysState[traylineIndex];
    for (const newTray of payload.trays) {
      const trayIndex = trayline.trays.findIndex(
        trayEl => trayEl.trayOid === newTray.trayOid,
      );
      if (trayIndex >= 0) {
        // console.log('Updating ticket', newTray);
        // trayline.trays[trayIndex] = newTray;
        // TODO: implement a more elegant solution.
        trayline = {
          ...trayline,
          trays: [...trayline.trays].map((tray, index) => {
            if (index === trayIndex) {
              return { ...newTray };
            }
            return { ...tray };
          }),
        };
      }
    }
    currentActiveTraysState[traylineIndex] = trayline;
    patchState({
      activeTrays: [...currentActiveTraysState],
    });
  }

  @Action(DeleteTrays)
  DeleteTray(
    { patchState, getState }: StateContext<CheckpointStateI>,
    { payload }: DeleteTrays,
  ): void {
    const currentActiveTraysState = [...getState().activeTrays];
    const traylineIndex = currentActiveTraysState.findIndex(
      tLine => tLine.trayLineOid === payload.trayLineOid,
    );
    let trayline = currentActiveTraysState[traylineIndex];
    for (const newTray of payload.trays) {
      const trayToDelete = trayline.trays.find(
        trayEl => trayEl.trayOid === newTray.trayOid,
      );
      if (!!trayToDelete) {
        trayline = {
          trayLineOid: trayline.trayLineOid,
          trays: [...trayline.trays].filter(
            el => el.trayOid !== trayToDelete.trayOid,
          ),
        };
      }
    }
    currentActiveTraysState[traylineIndex] = trayline;
    patchState({
      activeTrays: [...currentActiveTraysState],
    });
  }
}
